export const mapSelectedFeaturesArrayToSearchFiltersObject = (selectedParams) => {
  const searchTagsObject = {};
  selectedParams.forEach((param) => {
    if (param.features.length < 2) {
      if (param.multiselect) {
        searchTagsObject[param.slug] = searchTagsObject[param.slug] || [];

        searchTagsObject[param.slug].push(param.features[0].value);
      } else {
        searchTagsObject[param.slug] = param.features[0].value;
      }
    } else {
      searchTagsObject[param.slug] = searchTagsObject[param.slug] || [];

      const newParam = {};
      param.features.forEach((feature) => {
        newParam[feature.slug] = feature.value;
      });
      searchTagsObject[param.slug].push(newParam);
    }
  });
  return searchTagsObject;
};

export const validateUrl = (url) => {
  let newUrl = url;
  newUrl = newUrl.trim().replace(/\s/g, '');

  if (/^(:\/\/)/.test(newUrl)) {
    return `https${newUrl}`;
  }
  if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
    return `https://${newUrl}`;
  }

  return newUrl;
};

export const copyToClipboard = (elementId, succes, error) => {
  const codeToCopy = document.querySelector(`#${elementId}`);
  codeToCopy.setAttribute('type', 'text');
  codeToCopy.select();

  try {
    document.execCommand('copy');
    succes();
  } catch {
    error();
  }
  window.getSelection().removeAllRanges();
};

export const areObjectsDifferent = (firstObject, secondObject) => JSON.stringify(firstObject)
  !== JSON.stringify(secondObject);

export const nameInitials = (name) => {
  name.split(' ').map((n) => n[0]).join('').substr(0, 2);
};
